import React, { useState } from "react";
import "./UserTripsTutorialModal.css";

const LOCAL_KEY = "hideUserTripsTutorial";

export default function UserTripsTutorialModal({ onClose }) {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleClose = () => {
    if (dontShowAgain) {
      localStorage.setItem(LOCAL_KEY, "1");
    }
    onClose();
  };

  return (
    <div className="usertrips-tutorial-modal-overlay">
      <div className="usertrips-tutorial-modal">
        <button className="usertrips-tutorial-close-btn" onClick={handleClose} title="Close">&times;</button>
        <h2>User Trips Page Help</h2>
        <div className="usertrips-tutorial-content">
          <p>
            This page includes a list of trips that you created or that were shared with you.<br /><br />
            You can <strong>Create a new trip</strong> by pressing the <strong>'＋'</strong> button at the bottom right of the page.<br /><br />
            Once a trip is created, you can:
            <ul>
              <li>
                <strong>Open trip planning</strong> by double-clicking the trip or pressing the map icon <span className="usertrips-tutorial-icon" role="img" aria-label="Map">🗺️</span>.
              </li>
               <li>
                <strong>Get AI insights</strong> on the countries and cities/regions you plan to visit <span className="usertrips-tutorial-icon" role="img" aria-label="AI Insights">🪄</span>
              </li>
              <li>
                <strong>Share the trip</strong> with other users <span className="usertrips-tutorial-icon">🔗</span>
              </li>
               <li>
                <strong>Create another copy</strong> of the trip  <span className="usertrips-tutorial-icon">❐</span>
              </li>
              <li>
                <strong>Edit</strong> trip details <span className="usertrips-tutorial-icon">✎</span>
              </li>
              <li>
                <strong>Delete </strong>a trip <span className="usertrips-tutorial-icon">🗑</span>
              </li>
             
            </ul>
            <br />
            <strong>Note:</strong> For shared trips, you can only view the trip details in read-only mode (<span className="usertrips-tutorial-icon" role="img" aria-label="Map">🗺️</span>).
          </p>
        </div>
         <div className="tutorial-modal-actions">
          <label className="dont-show-label">
            <input
              type="checkbox"
              checked={dontShowAgain}
              onChange={(e) => setDontShowAgain(e.target.checked)}
            />
            <span>Don’t show this tutorial again</span>
          </label>
        </div>
        <div className="usertrips-tutorial-modal-arrow"></div>
      </div>
    </div>
  );
}